module.exports = __webpack_public_path__ + "static/fonts/GodoB.8607e8f.otf";